import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import FieldCheckbox_FormCommon from "./form/form-view"

export default function FieldCheckbox_FormElementView(props: FieldFormElementViewProps) {

    const value = props.field.getViewValue(props.model)

    return <FieldCheckbox_FormCommon className  = {props.className}
                                     field      = {props.field}
                                     value      = {value}
                                     disabled   = {props.disabled}
                                     onChange   = {props.onChange}/>
}